export const baseURL = process.env.REACT_APP_BASE_URL;
export const publicURL = process.env.REACT_APP_PUBLIC_URL;
export const homeURL = process.env.HOME_URL;
